import React from 'react';
import { useParams } from 'react-router-dom';
import { BodyText } from 'src/viewLayer/components/DesignSystem';

import { CONTENT_HOURS_BY_LEARN_LANG_MAPPING } from 'src/dataLayer/localData/contentHoursPerLangCombo';
import { getTextWithInterpolation } from 'src/viewLayer/components/shared/TextWithInterpolation/interpolate';
import TextWithPartialCustomStyling from 'src/viewLayer/components/shared/TextWithPartialCustomStyling';
import { t } from 'src/viewLayer/helpers/translations';
import '../index.scss';
import { LOCALE } from 'src/dataLayer/env';
import { DescriptionContainer } from './index.styled';

interface BoldTextType {
  children?: JSX.Element;
}

const BoldText: React.FC<BoldTextType> = ({ children, ...props }): JSX.Element =>
  <span style={{ fontWeight: 600 }} {...props}>{children}</span>;

export default ({ description }: { description: { key: string } }): JSX.Element => {
  const { learnLang } = useParams();
  const numberOfContentHours = CONTENT_HOURS_BY_LEARN_LANG_MAPPING[learnLang][LOCALE];

  return (
    <DescriptionContainer>
      <BodyText textAlign="center">
        {
          TextWithPartialCustomStyling({
            translationText: getTextWithInterpolation(
              t(description.key),
              { learnLang, number: numberOfContentHours }
            ),
            customStyledComponents: [BoldText, BoldText]
          }).map((TextPiece: JSX.Element) => TextPiece)
        }
      </BodyText>
    </DescriptionContainer>
  );
};
